const DataUploadStatus = Object.freeze({
  Update: 1,
  Skip: 2,
  Error: 3,
  Add: 4,
  Push: 5,
  Delete: 6,
});
export default DataUploadStatus;
